<div class="app-l-mc__sidepanel-wrap" [ngClass]="cssClass">
    <div class="app-l-mc__head">
        <div class="userevent-head">
            <label translate>eventAssign.selectOptionToAssign</label>
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                (click)="cancel()"
                (keypress)="cancel()">
                <svg-icon
                    icon="modal-close-button"
                    class="w-100 h-100"></svg-icon>
            </button>
        </div>
    </div>
    <div class="app-l-mc__body">
        <label class="required" translate>eventAssign.assignee</label>
        <mat-form-field>
            <mat-select
                class="wt-auto-login-organization"
                name="orgId"
                [placeholder]="
                    !selectedUser && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedUser"
                [disabled]="disableUserList">
                <ng-container *ngFor="let user of userList">
                    <mat-option *ngIf="user.Synched" [value]="user">
                        {{ user.fullName || user.Name }}
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <label class="required" translate>eventAssign.selectEventType</label>
        <mat-form-field>
            <mat-select
                class="wt-auto-login-organization"
                name="eventType"
                [(ngModel)]="selectedEventType"
                [disabled]="disableEventList"
                [placeholder]="
                    !selectedEventType && 'eventAssign.chooseFromList'
                        | translate
                "
                (ngModelChange)="onChangeEventType()">
                <mat-option *ngFor="let event of eventTypeList" [value]="event">
                    {{ event.name | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <label
            class="required" *ngIf = "showSeriesType && selectedEventType?.subType?.length "
            translate>
            eventAssign.selectSeriesType
        </label>
        <mat-form-field *ngIf = "showSeriesType && selectedEventType?.subType?.length ">
            <mat-select
                class="wt-auto-login-organization"
                name="event-single-select"
                [placeholder]="
                    !selectedEventSeriesType && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedEventSeriesType">
                <ng-container
                    *ngFor="let option of selectedEventType?.subType">
                    <mat-option
                        [value]="option"
                        translate>
                        <span [translate]="option.name"></span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>


        <label
            class="required"
            *ngIf="selectedEventType?.subOptions?.length  && !showSeriesType "
            translate
            >eventAssign.selectSpecificTask</label
        >
        <mat-form-field
            *ngIf="
                selectedEventType?.subOptions?.length &&
                !selectedEventType.multiSelect && !showSeriesType
            ">
            <mat-select
                class="wt-auto-login-organization"
                name="event-single-select"
                [placeholder]="
                    !selectedEvent && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedEvent">
                <ng-container
                    *ngFor="let option of selectedEventType?.subOptions">
                    <mat-option
                        *ngIf="option.enabled"
                        [value]="option"
                        translate>
                        <span [translate]="option.name"></span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <label
            class="required"
            *ngIf="selectedEventSeriesType?.subOptions?.length && showSeriesType && selectedEventSeriesType"
            translate
            >eventAssign.selectSpecificTask</label
        >
        <mat-form-field
        *ngIf="selectedEventSeriesType?.subOptions?.length && selectedEventType.multiSelect && showSeriesType && selectedEventSeriesType.key === 'video'">
            <mat-select
                class="wt-auto-login-organization"
                name="event-multi-select"
                [placeholder]="
                    !selectedEvent && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedEvent"
                [multiple]="true">
                <ng-container
                    *ngFor="let option of selectedEventSeriesType?.subOptions">
                    <mat-option
                        *ngIf="option.enabled"
                        [value]="option"
                        translate>
                        <span [translate]="option.name"></span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

        <mat-form-field
        *ngIf="selectedEventSeriesType?.subOptions?.length && selectedEventType.multiSelect && showSeriesType && selectedEventSeriesType.key !== 'video'">
            <mat-select
                class="wt-auto-login-organization"
                name="event-multi-select"
                [placeholder]="
                    !selectedEvent && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedEvent"
                [multiple]="true">
                <ng-container
                    *ngFor="let option of selectedEventSeriesType?.subOptions">
                    <mat-option
                        [value]="option"
                        translate>
                        <span [translate]="option.name"></span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>

    <!-- <label class="required" translate>eventAssign.selectEventType</label> -->
       <!--  <mat-form-field
            *ngIf="
                selectedEventType?.subOptions?.length &&
                selectedEventType.multiSelect && selectedEventSeriesType
            ">
            <mat-select
                class="wt-auto-login-organization"
                name="event-multi-select"
                [placeholder]="
                    !selectedEvent && 'eventAssign.chooseFromList' | translate
                "
                [(ngModel)]="selectedEvent"
                [multiple]="true">
                <ng-container
                    *ngFor="let option of selectedEventType?.subOptions">
                    <mat-option
                        [value]="option"
                        translate>
                        <span [translate]="option.name"></span>
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field> -->

        <label class="required" translate
            >eventAssign.SuggestedCompletionDate</label
        >
        <div class="app-c-datepicker app-c-form-group">
            <input
                class="app-c-form-control"
                [owlDateTime]="dt1"
                [owlDateTimeTrigger]="dt1"
                placeholder="Select Date"
                [(ngModel)]="selectedDate"
                [min]="minDate" />
            <div class="app-c-datepicker__icon">
                <svg-icon icon="calendar"></svg-icon>
            </div>
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
    </div>
    <div class="footer-popup">
        <button
            tabindex="0"
            class="app-c-btn app-c-btn--secondary"
            (click)="cancel()"
            (keypress)="cancel()">
            <!-- *ngIf="!optionChanged" -->
            <span translate>blocked.close</span>
        </button>
        <button
            class="app-c-btn app-c-btn--primary"
            tabindex="0"
            [disabled]="
            !selectedUser ||
            !selectedEventType ||
            (selectedEventType?.type === 'series'
                ? (!selectedEventSeriesType || !selectedEvent)
                : (selectedEventType?.subOptions && !selectedEvent)
            ) ||
            isLoading
        "
            (click)="onSubmit()"
            (keypress)="onSubmit()">
            <span translate>eventAssign.assign</span>
            <!-- <svg-icon icon="tick"></svg-icon> -->
            <img *ngIf="isLoading" alt="Loading" src="/assets/img/loader.gif" class="loader-gif-sm" />
        </button>
    </div>
</div>
<span class="app-l-mc__overlay" (click)="cancel()" (keypress)="cancel()"></span>
